import { render } from "./PagoStatus.vue?vue&type=template&id=653c0ed0"
import script from "./PagoStatus.vue?vue&type=script&lang=js"
export * from "./PagoStatus.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__